import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../Filters/Filters.scss';

const DateRangeFilter = ({
  label,
  sName = '',
  eName = '',
  startDate,
  endDate,
  onChange,
  placeholderText = 'Select date range',
  minDate,
  maxDate,
  allowLowRange = true,
  allowHighRange = true,
  onBlur
}) => {
  // Convert string dates to Date objects for DatePicker
  const minDateObj = minDate ? new Date(minDate) : null;
  const maxDateObj = maxDate ? new Date(maxDate) : null;

  return (
    <div className="filter-control">
      {label && <label className="filter-label">{label}</label>}
      <div className="date-range-container">
        {allowLowRange && (
          <DatePicker
            selected={startDate}
            onChange={(date) => {
              // If end date is selected and new start date is after end date, update end date
              const newEndDate = endDate && date && date > endDate ? date : endDate;
              onChange && onChange({ startDate: date, endDate: newEndDate });
            }}
            onBlur={onBlur}
            className="date-input"
            name={sName}
            dateFormat="MMM dd, yyyy"
            placeholderText="From date"
            selectsStart
            startDate={startDate}
            endDate={endDate}
            minDate={minDateObj}
            maxDate={maxDateObj}
          />
        )}
        {allowHighRange && (
          <DatePicker
            selected={endDate}
            onChange={(date) => {
              // If start date is selected and new end date is before start date, update start date
              const newStartDate = startDate && date && date < startDate ? date : startDate;
              onChange && onChange({ startDate: newStartDate, endDate: date });
            }}
            onBlur={onBlur}
            name={eName}
            className="date-input"
            dateFormat="MMM dd, yyyy"
            placeholderText="To date"
            selectsEnd
            startDate={startDate}
            endDate={endDate}
            minDate={startDate || minDateObj}
            maxDate={maxDateObj}
          />
        )}
      </div>
    </div>
  );
};

export default DateRangeFilter;

